export const decoratorSlideVariant = {
  left: {
    wrapperClass: "flex flex-row-reverse",
    lineClass: "bg-gradient-to-l",
  },
  right: {
    wrapperClass: "flex",
    lineClass: "bg-gradient-to-r",
  },
};
